// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"294ca155","488":"4336f2a0"}[chunkId] + ".chunk.js";
};